import React, { useEffect, useState } from "react";
import "./Electrician.css"
import { useNavigate } from "react-router-dom";
const Electrician = ({ cart, addToCart }) => {
  const [openService, setOpenService] = useState(null);
  const navigate = useNavigate();
  const services = [
    {
      id: 101,
      title: "Switchboard Repair / Replacement",
      price: 449,
      subtitle: "Fix or replace damaged switchboard safely",
      extra_detail_1: "Repair damaged or faulty switchboards safely and efficiently.",
      extra_detail_2: "Replace old or loose switchboards with secure and reliable fittings.",
      image: "https://5.imimg.com/data5/OD/OS/AE/SELLER-5064319/electrical-switches-500x500.jpg"
    },
    {
      id: 102,
      title: "Window AC Jet Service",
      price: 399,
      subtitle: "Repair broken switches and loose sockets",
      extra_detail_1: "High-pressure jet cleaning removes dirt and dust.",
      extra_detail_2: "Improves cooling performance and airflow efficiency.",
      image: "https://5.imimg.com/data5/SELLER/Default/2023/11/364087157/FT/AS/OE/89904417/window-air-conditioner-jet-pump-maintenance-service.jpeg"
    },
    {
      id: 103,
      title: "New Switch Box Installation",
      price: 99,
      subtitle: "Install a brand new switch box securely",
      extra_detail_1: "Install a new switch box safely and securely.",
      extra_detail_2: "Ensures proper wiring and reliable power connections.",
      image: "https://5.imimg.com/data5/AB/UO/MY-40054269/cona-3-in-one-combine-with-j-box.jpg"
    },
    {
      id: 104,
      title: "Fan Repair",
      price: 99,
      subtitle: "Fix fan not working, noise or slow speed",
      extra_detail_1: "Fix faulty fans for smooth and quiet operation.",
      extra_detail_2: "Repair wiring, motor issues, or loose connections.",
      image: "https://orpatgroup.com/wp-content/uploads/2022/12/brown-fan-1.jpg"
    },
    {
      id: 105,
      title: "Exhaust / Pedestal / Tower Fan Installation",
      price: 99,
      subtitle: "Professional fan fitting with neat wiring",
      extra_detail_1: "Install exhaust, pedestal, or tower fans properly.",
      extra_detail_2: "Ensures safe fitting and smooth fan operation.",
      image: "https://impexstore.com/cdn/shop/products/31Nl4SdB5mS.jpg?v=1661235514"
    },
    {
      id: 106,
      title: "Fan Regulator Replacement",
      price: 99,
      subtitle: "Replace faulty fan speed regulator",
      extra_detail_1: "Replace faulty fan regulators with new reliable ones.",
      extra_detail_2: "Ensures smooth fan speed control and safe operation.",
      image: "https://ecm.mea.panasonic.com/wp-content/uploads/2024/02/WDBA4555-N.webp"
    },
    {
      id: 107,
      title: "Karban Airzone Fan Installation",
      price: 99,
      subtitle: "Install premium Airzone fan safely",
      extra_detail_1: "Install premium Airzone fan safely and securely",
      extra_detail_2: "Ensures proper fitting and smooth fan performance",
      image: "https://m.media-amazon.com/images/I/61rUO2jkZTL.jpg"
    },
    {
      id: 108,
      title: "Fancy Light Installation / Replacement",
      price: 99,
      subtitle: "Install or replace designer fancy lights",
      extra_detail_1: "Install or replace designer fancy lights safely.",
      extra_detail_2: "Enhances room lighting with stylish illumination",
      image: "https://media.istockphoto.com/id/1472464806/photo/decorative-antique-edison-style-filament-light-bulbs-hanging-an-electrician-is-installing.jpg?s=612x612&w=0&k=20&c=3wirHrNX0E-pN-UTaAJhQ18jyoCuUM3ZwOaUHwqbls0="
    },

    {
      id: 109,
      title: "Tubelight Installation",
      price: 99,
      subtitle: "Safe and quick tube light installation",
      extra_detail_1: "Install tube lights safely for bright illumination",
      extra_detail_2: "Ensures secure fitting and proper electrical connection",
      image: "https://4.imimg.com/data4/BY/VJ/MY-5140526/led-tube-light.jpg"
    },

    {
      id: 110,
      title: "Bulb Installation",
      price: 99,
      subtitle: "Install bulb in any room or space",
      extra_detail_1: "Install bulbs safely in any room or space",
      extra_detail_2: "Ensures proper fitting and reliable lighting.",
      image: "https://www.thespruce.com/thmb/1KnFJqoAsqW8zgHUFuKNvzFpMpg=/6000x4000/filters:no_upscale()/SPR-how-to-install-recessed-lighting-5192848-hero-01a3c4a146e9471fb16cc1db0d6429c0.jpg"
    },
    {
      id: 111,
      title: "Ceiling Light Installation",
      price: 99,
      subtitle: "Fix ceiling lights properly and safely",
      extra_detail_1: "Fix ceiling lights securely and ensure safe operation",
      extra_detail_2: "Restores proper lighting and stable electrical connections",
      image: "https://cdn.store.link/products/store2500/o2vcli-whatsapp%20image%202023-12-06%20at%2011.28.13%20pm.jpeg?versionId=F2y7tCepsE.fulnGm.lzW39Rn7Sgkc9V"
    },
    {
      id: 112,
      title: "Hanging Light Installation",
      price: 99,
      subtitle: "Install hanging lights with proper support",
      extra_detail_1: "Install hanging lights securely with proper support",
      extra_detail_2: "Ensures safe fitting and balanced illumination",
      image: "https://m.media-amazon.com/images/I/51VdmNOOAkL._AC_UF1000,1000_QL80_.jpg"
    },
    {
      id: 113,
      title: "Chandelier Installation",
      price: 99,
      subtitle: "Expert chandelier fitting with care",
      extra_detail_1: "Expert chandelier installation with careful handling",
      extra_detail_2: "Ensures secure mounting and elegant lighting",
      image: "https://m.media-amazon.com/images/I/71vBATJ3uzL.jpg"
    },
    {
      id: 114,
      title: "Internal Wiring (Per Meter)",
      price: 99,
      subtitle: "New internal electrical wiring work",
      extra_detail_1: "Install new internal electrical wiring safely and neatly.",
      extra_detail_2: "Ensures reliable power supply throughout the home",
      image: "https://content.misumi-ec.com/image/upload/t_product_main/v1/p/jp/product/series/222005697441/222005697441_001.jpg"
    },
    {
      id: 115,
      title: "External Wiring (Per Meter)",
      price: 99,
      subtitle: "Safe and neat external wiring setup",
      extra_detail_1: "Install external wiring safely with neat arrangement",
      extra_detail_2: "Ensures durable connections and reliable outdoor power",
      image: "https://content.misumi-ec.com/image/upload/t_product_main/v1/p/jp/product/series/222005697441/222005697441_001.jpg"
    },
    {
      id: 116,
      title: "Regular Doorbell Installation",
      price: 99,
      subtitle: "Install normal doorbell at your home",
      extra_detail_1: "Install normal doorbell quickly at your home",
      extra_detail_2: "Ensures proper wiring and clear ringing sound",
      image: "https://www.wmhendersoninc.com/wp-content/uploads/2023/09/How-Does-Doorbell-Work-House-Photo.jpg"
    },
    {
      id: 117,
      title: "Video Doorbell Installation",
      price: 99,
      subtitle: "Install smart video doorbell securely",
      extra_detail_1: "Install smart video doorbell securely at entrance.",
      extra_detail_2: "Ensures proper setup and clear video monitoring.",
      image: "https://m.media-amazon.com/images/I/61-WZ9X7ppL._AC_UF1000,1000_QL80_.jpg"
    },
    {
      id: 118,
      title: "MCB / Fuse Repair",
      price: 99,
      subtitle: "Fix tripping MCBs or blown fuses",
      extra_detail_1: "Repair tripping MCBs and replace blown fuses.",
      extra_detail_2: "Ensures stable power and electrical safety.",
      image: "https://cdnus.globalso.com/cncele/40-amp-double-pole-mcb.jpg"
    },
    {
      id: 119,
      title: "Inverter Fuse Replacement",
      price: 99,
      subtitle: "Replace damaged inverter fuse",
      extra_detail_1: "Replace damaged inverter fuse safely and quickly",
      extra_detail_2: "Ensures proper backup power and protection",
      image: "https://5.imimg.com/data5/LP/JJ/MY-22613640/glass-fuse.jpg"
    },
    {
      id: 120,
      title: "Sub Meter Installation",
      price: 99,
      subtitle: "Install separate home / room meter",
      extra_detail_1: "Install separate meter for home or room",
      extra_detail_2: "Ensures accurate electricity usage monitoring",
      image: "https://m.media-amazon.com/images/I/61Jh79e8k3L._AC_UF1000,1000_QL80_.jpg"
    },
    {
      id: 121,
      title: "TV Installation",
      price: 99,
      subtitle: "Wall mount and setup your television",
      extra_detail_1: "Mount your television securely on the wall",
      extra_detail_2: "Ensures proper setup and safe installation",
      image: "https://fudsinternational.com/cdn/shop/files/22_TVInstallationtill32.png?v=1740146960"
    },
    {
      id: 122,
      title: "TV Uninstallation",
      price: 99,
      subtitle: "TV Uninstallation",
      extra_detail_1: "Safely uninstall TV from wall or stand",
      extra_detail_2: "Ensures careful removal without damaging wires.",
      image: "https://fudsinternational.com/cdn/shop/files/22_TVInstallationtill32.png?v=1740146960"
    },
    {
      id: 123,
      title: "Inverter Installation",
      price: 99,
      subtitle: "Install inverter with proper connections",
      extra_detail_1: "Install inverter with secure and proper connections",
      extra_detail_2: "Ensures reliable backup power for your home",
      image: "https://www.batteryestore.com/cdn/shop/products/ecowatt850_rc16000_1024x1024@2x.png?v=1595684375"
    },
    {
      id: 124,
      title: "Inverter Fuse Replacement",
      price: 99,
      subtitle: "Replace damaged inverter fuse",
      extra_detail_1: "Replace damaged inverter fuse safely and quickly",
      extra_detail_2: "Restores proper protection and power flow",
      image: "https://www.electricallearner.in/wp-content/uploads/2021/10/20211015_114111-scaled.jpg"
    },
    {
      id: 125,
      title: "Inverter Servicing",
      price: 99,
      subtitle: "Full health check and service of inverter",
      extra_detail_1: "Perform complete inverter health check and service",
      extra_detail_2: "Ensures reliable backup power and smooth performance",
      image: "https://productimages.withfloats.com/serviceimages/tile/61f1748b2452f967c1813d7e4c5772a1-bfd4-4fa2-88f6-483aff72650d.png"
    },
    {
      id: 126,
      title: "Inverter Check-up",
      price: 99,
      subtitle: "Basic inverter health inspection",
      extra_detail_1: "Inspect inverter for basic health and safety",
      extra_detail_2: "Checks connections, battery status, and performance",
      image: "https://productimages.withfloats.com/serviceimages/tile/61f1748b2452f967c1813d7e4c5772a1-bfd4-4fa2-88f6-483aff72650d.png"
    },
    {
      id: 127,
      title: "Inverter Uninstallation",
      price: 99,
      subtitle: "Remove inverter safely and cleanly",
      extra_detail_1: "Safely remove inverter without damaging wiring",
      extra_detail_2: "Ensures clean and careful uninstallation",
      image: "https://productimages.withfloats.com/serviceimages/tile/61f1748b2452f967c1813d7e4c5772a1-bfd4-4fa2-88f6-483aff72650d.png"
    },
    {
      id: 128,
      title: "Stabilizer Installation",
      price: 99,
      subtitle: "Install stabilizer for safe voltage use",
      extra_detail_1: "Install stabilizer for safe and stable voltage",
      extra_detail_2: "Protects appliances from voltage fluctuations",
      image: "https://www.ato.com/content/images/thumbs/0003609_2-kva-single-phase-automatic-voltage-stabilizer-for-home_550.jpeg"
    },
    {
      id: 129,
      title: "Sub Category",
      price: 99,
      subtitle: "General electrical service",
      extra_detail_1: "Basic installation or inspection service",
      extra_detail_2: "Suitable for minor electrical needs",
      image: "https://images.unsplash.com/photo-1621905252507-b35492cc74b4"
    },
    {
      id: 130,
      title: "Decorative Fan Installation",
      price: 149,
      subtitle: "Install designer ceiling fans",
      extra_detail_1: "Proper wiring and mounting of decorative fans",
      extra_detail_2: "Ensure safe and balanced installation",
      image: "https://images.openai.com/static-rsc-3/kGpffqBuPskA5SlMLmgw1NNpKCGdqytitV0USC7-KDfih8pDrbTIaJbKEBe8pUW7XYeHDAd3zdulnskWuOr-lww9XlZMFOAB5NH8lWq3kfM?purpose=inline"
    },
    {
      id: 131,
      title: "Regular Ceiling Fan Installation",
      price: 99,
      subtitle: "Install standard ceiling fans",
      extra_detail_1: "Secure mounting and wiring connection",
      extra_detail_2: "Ensure smooth and stable operation",
      image: "https://images.openai.com/static-rsc-3/NptAORh0uuUZhMpKOGiLAgqDtlEOC7dQ1sxFClhBi_0UxKIq4RkWM77jIZB_iZ3C-rLDYB_4RAfufPLHor_Ipp1MhsE4j1R7mp8dhPm4TO8?purpose=inline"
    },
    {
      id: 132,
      title: "Smart / BLDC Fan Installation",
      price: 199,
      subtitle: "Install energy-efficient smart fans",
      extra_detail_1: "Setup BLDC or remote-controlled fans",
      extra_detail_2: "Ensure proper connectivity and function",
      image: "https://m.media-amazon.com/images/I/51VFEnuNdnL._AC_UF894%2C1000_QL80_.jpg"
    },
    {
      id: 133,
      title: "Sound Bar Installation",
      price: 149,
      subtitle: "Install sound bars for home audio",
      extra_detail_1: "Wall mount or TV unit placement",
      extra_detail_2: "Ensure proper audio connection setup",
      image: "https://www.ooberpad.com/cdn/shop/articles/Ooberpad-blog-Featured_thumbnail_Soundbar_Optical_HDMI-cables_img_3381fe22-c5bd-46e0-880f-38986410b50b.jpg?v=1763557340"
    }
  ];

  return (
    <div className="container-fluid service-electrician">
      <div id="Electronic">
        <h1>Electronic</h1>
      </div>
      <div className="elect-container">

        {/* LEFT SIDE - SERVICES */}
        <div className="services-section-elect">
          {services.map((service) => {
            const isAdded = cart.some(
              item => item.id === service.id && item.category === service.category
            );
            return (
              <div key={service.id} className="service-card-elect">

                <div className="service-details-elect">
                  <h3>{service.title}</h3>

                  <div className="price-section-elect">
                    <span className="new-price-elect">₹{service.price}</span>
                  </div>
                  <button
                    className=" btn btn-link view-details-elect"
                    onClick={() =>
                      setOpenService(openService === service.id ? null : service.id)
                    }
                  >
                    View Details
                  </button>
                  {openService === service.id && (
                    <div className="extra-details-elect">
                      <p>✔ {service.extra_detail_1}</p>
                      <p>✔ {service.extra_detail_2}</p>
                    </div>
                  )}
                  <ul>
                    <li>{service.subtitle}</li>
                  </ul>
                </div>

                <div className="service-image-elect">
                  <img src={service.image} alt="" /><br />
                  <button
                    onClick={() => addToCart(service)}
                    className={`btn px-5 mt-2 ${isAdded ? "btn-success" : "btn-warning"
                      }`}
                  >
                    {isAdded ? "Added" : "Add"}
                  </button>
                </div>

              </div>
            );
          })}
        </div>

      </div>
    </div>
  )
}

export default Electrician